import { Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { BildungsangebotTerminDetail } from '../../../../../model';
import { getKostenKurzbezeichnungWithBoundary, Kosten } from '../../../../../model/kosten';
import { SanitizerService } from '../../../../../services/sanitizer.service';

@Component({
  selector: 'now-wbsuche-lib-kosten-gebuehren',
  templateUrl: './kosten-gebuehren.component.html',
  styleUrls: ['../keywords.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: []
})
export class KostenGebuehrenComponent {
  private readonly sanitizerService = inject(SanitizerService);

  @Input()
  public termin!: BildungsangebotTerminDetail;

  sanitizeFunction(html?: string): string {
    return this.sanitizerService.sanitize(html);
  }

  get kosten(): string {
    return getKostenKurzbezeichnungWithBoundary(this.termin.kostenWert).bezeichnung;
  }

  get kostenAria(): string {
    return getKostenKurzbezeichnungWithBoundary(this.termin.kostenWert).ariaLabel;
  }

  protected readonly Kosten = Kosten;
}
